import { isAbsoluteUrl } from '@/utils/url/isAbsoluteUrl';
import classNames from 'classnames';
import React from 'react';
import { useHistory } from 'umi';
import css from './index.less';

export interface BreadCrumbsRoute {
  name: string;
  url?: string;
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export interface Props {
  routes?: BreadCrumbsRoute[];
}

export const BreadCrumbs: React.FC<Props> = ({ routes }) => {
  const history = useHistory();
  return routes?.length ? (
    <div id="page-bread-crumbs" className={css.breadCrumbs}>
      {routes.map(({ name, url, title, onClick }, index) => {
        const isLast = index === routes.length - 1;
        const className = classNames(css.item, {
          [css.itemActive]: isLast,
        });
        return (
          <React.Fragment key={name}>
            {url ? (
              <a
                className={className}
                href={url}
                title={title || name}
                onClick={(e) => {
                  if (onClick) {
                    onClick(e);
                  } else if (!isAbsoluteUrl(url)) {
                    e.preventDefault();
                    history.push(url);
                  }
                }}
              >
                {name}
              </a>
            ) : (
              <span className={className}>{name}</span>
            )}
            {!isLast && <span className={css.separator}>/</span>}
          </React.Fragment>
        );
      })}
    </div>
  ) : null;
};

export default BreadCrumbs;
